<template>
  <section class="embedded-pbi-report">
    <div class="embedded-pbi-report__container">
          <div
      class="embedded-pbi-report__report"
      id="embedded-report"
      v-show="!loading"
      ></div>
      <q-inner-loading :showing="this.loading">
        <q-spinner size="50px" color="secondary" />
        <span class="embedded-pbi-report__loading">Please wait... </span>
      </q-inner-loading>
    </div>

    <div class="embedded-pbi-report__error" v-if="this.error">
      <span>Could not load report</span>
    </div>
  </section>
</template>

<script>
import * as pbi from "powerbi-client";
const powerbi = new pbi.service.Service(
  pbi.factories.hpmFactory,
  pbi.factories.wpmpFactory,
  pbi.factories.routerFactory
);
export default {
  name: "PowerbiEmbeddedReport",
  props: {
    reportId: {
      type: String,
      required: true,
    },
    datasetId: String,
    groupId: String,
    filterPaneEnabled: String,
    navContentPaneEnabled: String,
  },
  data() {
    return {
      loading: true,
      error: false,
      embedToken: null,
      userPbiRoles: null,
      reportLoadConfig: {
        type: "report",
        tokenType: pbi.models.TokenType.Embed,
        accessToken: null,
        embedUrl: null,
        settings: {
          panes: {
            pageNavigation: {
              visible: this.$props.navContentPaneEnabled === "true",
            },
            filters: {
              visible: this.$props.filterPaneEnabled === "true",
            },
          },
        },
      },
    };
  },
  watch:{
    reportId(){
      this.getUserPbiRoles();
    }
  },
  methods: {
    // Get User roles
    getUserPbiRoles() {
      this.userPbiRoles = this.$store.getters.getPbiRoles;
      if (this.userPbiRoles.length >= 1) {
        this.loadReport();
      } else {
        this.error = true;
      }
    },

    // Embed report
    loadReport() {
      const payload = {
        reportId: this.reportId,
        userRoles: this.userPbiRoles,
        urlPath: this.$route.path, // Send the current URL path
      };

      if (this.datasetId) {
        payload.datasetId = this.datasetId;
      }

      if (this.groupId) {
        payload.groupId = this.groupId;
      }

      const reportContainer = document.getElementById("embedded-report");

      this.$store
        .dispatch("fetchPbiAccessToken", payload)
        .then(({ data }) => {
          const report = powerbi.embed(reportContainer, {
            // Load the report config, access token and embedded url
            ...this.reportLoadConfig,
            accessToken: data.embedData.token,
            embedUrl: data.url,
          });
          // State handling - remove loader and show report
          report.on("loaded", async () => {
            this.loading = false;
          });
          // Handle data click event - can pull data through to frontend
          report.on("dataSelected", function(event) {
            let data = event.detail;
            console.log("Event - dataSelected:\n", data);
          });
          report.off("rendered", function() {});
        })
        .catch((error) => {
          console.log("Could not fetch access token:" + error);
          this.$store.dispatch("logout");
        });
    },
  },
  mounted() {
    this.getUserPbiRoles();
  },
};
</script>
